import $ from 'jquery'
import 'select2'

function init() {
    setUpSelects()
}

function setUpSelects() {
    $('select').each((index, select) => {
        select = $(select)

        let parent = select.closest('.col'),
            width = 236
        
        if ($('body').hasClass('plan_builder show') || $('body').hasClass('plan_builder preview')) {
            parent = select.closest('.coverage')
            width = 473
        }

        select.select2({
            width: width,
            placeholder: 'County of Coverage',
            minimumResultsForSearch: Infinity,
            dropdownParent: parent
        })
    })
}

export default { init }